import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offline" }
const _hoisted_2 = { class: "offline_contents" }
const _hoisted_3 = { class: "offline_title" }
const _hoisted_4 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _createElementVNode("img", {
          src: `img/offline/${_ctx.lang}/title.svg`,
          alt: _ctx.alt[_ctx.lang]
        }, null, 8, _hoisted_4)
      ])
    ])
  ]))
}